import axios from 'axios'
// import { getField, updateField } from 'vuex-map-fields'
export default {
  state: {
    productInfo: [],
    productItem: [],
    productMaster: [],
    productItemRender: [],
    getStyleClass: [],
    getProductStyle: [],
    productName: '',
    categoryName: '',
    categoryId: null,
    productId: null,
    id: null,
    specId: null,
    sizeId: null,
    styleId: null,
    pagination: [],
    activePage: null,
    templateImgCount: null,
    selectedStyleId: null,
    // 20230925 月曆版型分類
    styleProductMaster: [],
    styleItem: [],
    styleCategory: [],
    // 20240524 產品模板與尺寸
    specName: '',
    size: ''
  },
  actions: {
    getStyleDetailList (context, {id, specId, sizeId, sortingKey}) {
      let API_PATH = process.env.API
      let getAPI = `${API_PATH}product/getdetaillist/${id}/${specId}/${sizeId}/${sortingKey}/16`
      context.commit('LOADING', true, {root: true})
      return axios.get(getAPI).then((response) => {
        let {productItem, productMaster, productStyle} = response.data.data
        let {productName, categoryName, categoryId, specName, size} = productItem[0]
        // count pagination
        let pagination = []
        productItem.forEach(itm => {
          if (pagination.indexOf(itm.page_no) === -1) {
            pagination.push(itm.page_no)
          }
          // 若有參數 parameter_pagestyle
          if (itm.parameter_pagestyle) {
            itm.editLink += '&' + itm.parameter_pagestyle
          }
        })
        context.commit('setStyleData', {productItem, id, specId, sizeId, productName, categoryName, categoryId, pagination, productMaster, productStyle, specName, size})
      }).catch((error) => {
        console.log(error)
      })
    },
    getStyleClass (context, {id}) {
      let API_PATH = process.env.API
      let getAPI = `${API_PATH}product/getstyle/${id}`
      return axios.get(getAPI).then((response) => {
        let getStyleClass = response.data
        getStyleClass.splice(0, 0, {
          created_at: null,
          enabled: 'Y',
          productId: 0,
          styleCode: '0',
          styleIcon: null,
          styleId: 0,
          styleName: '全部',
          updated_at: null
        })
        context.commit('setStyleClass', {getStyleClass})
        context.commit('LOADING', false, {root: true})
      }).catch((error) => {
        console.log(error)
      })
    },
    // 20230925 月曆版型分類
    getProductStyle (context, {id, specId, sizeId, sortingKey}) {
      // context.commit('LOADING', true, {root: true})
      let API_PATH = process.env.API
      let getAPI = `${API_PATH}product/getdetaillist/${id}/${specId}/${sizeId}/${sortingKey}/16`
      // context.commit('LOADING', true, {root: true})
      return axios.get(getAPI).then((response) => {
        let {productMaster: styleProductMaster, productItem: styleItem, productStyle: styleCategory} = response.data.data
        // let {productName, categoryName, categoryId} = styleProductMaster[0]
        // count pagination
        let pagination = []
        styleItem.forEach(itm => {
          if (pagination.indexOf(itm.page_no) === -1) {
            pagination.push(itm.page_no)
          }
        })
        context.commit('setStyleItem', {id, specId, sizeId, pagination, styleProductMaster, styleItem, styleCategory})
      }).catch((error) => {
        console.log(error)
      })
    },
    // 換風格重新抓一次資料
    // 20230918 styleId
    // changeStyle (context, {changeStyleId}) {
    //   let API_PATH = process.env.API
    //   let {id, specId, sizeId, styleId} = context.state
    //   let getAPI = `${API_PATH}product/getdetaillist/${id}/${specId}/${sizeId}/${changeStyleId}/16`
    //   context.commit('LOADING', true, {root: true})
    //   axios.get(getAPI).then((response) => {
    //     let {productItem, productMaster, productStyle} = response.data.data
    //     let {productName, categoryName, categoryId} = context.state
    //     console.log(styleId)
    //     // 算pagination
    //     let pagination = []
    //     productItem.forEach(itm => {
    //       if (pagination.indexOf(itm.page_no) === -1) {
    //         pagination.push(itm.page_no)
    //       }
    //     })
    //     context.commit('setStyleData', {productItem, id, specId, sizeId, styleId, productName, categoryName, categoryId, pagination, productMaster, changeStyleId, productStyle})
    //     context.commit('LOADING', false, {root: true})
    //   }).catch((error) => {
    //     console.log(error)
    //   })
    // },
    // 換排序 換風格 重新抓一次資料
    changeSorting (context, {sortingKey, styleKey}) {
      let API_PATH = process.env.API
      let {id, specId, sizeId} = context.state
      let getAPI = ''
      if (styleKey === 0) {
        getAPI = `${API_PATH}product/getdetaillist/${id}/${specId}/${sizeId}/${sortingKey}/16`
      } else {
        getAPI = `${API_PATH}product/getdetailwithstyle/${id}/${specId}/${sizeId}/${styleKey}/${sortingKey}/16`
      }
      context.commit('LOADING', true, {root: true})
      axios.get(getAPI).then((response) => {
        let {productItem, productMaster, productStyle} = response.data.data
        let {productName, categoryName, categoryId, specName, size} = context.state
        // 算pagination
        let pagination = []
        productItem.forEach(itm => {
          if (pagination.indexOf(itm.page_no) === -1) {
            pagination.push(itm.page_no)
          }
          // 若有參數 parameter_pagestyle
          if (itm.parameter_pagestyle) {
            itm.editLink += '&' + itm.parameter_pagestyle
          }
        })
        context.commit('setStyleData', {productItem, id, specId, sizeId, productName, categoryName, categoryId, pagination, productMaster, productStyle, specName, size})
        context.commit('LOADING', false, {root: true})
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  mutations: {
    setStyleData (state, {productItem, id, specId, sizeId, productName, categoryName, categoryId, pagination, productMaster, changeStyleId, productStyle, specName, size}) {
      state.productItem = productItem
      state.productMaster = productMaster
      state.getProductStyle = productStyle
      state.templateImgCount = productMaster[0].templateImgCount
      state.productItemRender = productItem
      state.productName = productName
      state.categoryName = categoryName
      state.categoryId = categoryId
      state.id = id
      state.productId = productMaster[0].productId
      state.specId = specId
      state.sizeId = sizeId
      state.styleId = productItem[0].styleId
      state.selectedStyleId = changeStyleId
      state.pagination = pagination
      state.activePage = pagination[0]
      state.specName = specName
      state.size = size
    },
    setStyleItem (state, {id, specId, sizeId, productName, categoryName, categoryId, pagination, styleProductMaster, styleItem, styleCategory, specName, size}) {
      state.styleItem = []
      state.styleProductMaster = []
      state.styleCategory = []
      state.styleItem = styleItem
      state.styleProductMaster = styleProductMaster
      state.styleCategory = styleCategory
      state.templateImgCount = styleProductMaster[0].templateImgCount
      // state.styleItemRender = productItem
      // state.productName = productName
      // state.categoryName = categoryName
      // state.categoryId = categoryId
      state.id = id
      state.specId = specId
      state.sizeId = sizeId
      // state.styleId = styleItem.styleId
      // state.selectedStyleId = changeStyleId
      state.pagination = pagination
      state.activePage = pagination[0]
    },
    setStyleClass (state, {getStyleClass}) {
      state.getStyleClass = getStyleClass
    },
    setProductStyle (state, {productStyle, productItem}) {
      state.getProductStyle = productStyle
      state.productItem = productItem
    }
  },
  getters: {
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/styleSearch.js